import apiClient from '../../../lib/client';

export async function lookupAddress(address) {
  const { data } = await apiClient.post('/lookup/address', { address });
  return data;
}
